import { ListItemIcon, ListItemText } from '@/components/Dropdown/MenuItems/components';
import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import { useAnalytics } from '@/services/analytics';
import theme from '@/theme';
import { ICampaign } from '@d-id/types';
import MenuItem from '@mui/material/MenuItem';

interface Props {
    campaign: ICampaign;
    closeMenu: () => void;
    onClick: (event: React.MouseEvent<HTMLElement>) => void;
    mixPanelEvent: string;
    icon: string;
    text: string;
}

export const CampaignMenuItem = ({ campaign, closeMenu, onClick, icon, text, mixPanelEvent }: Props) => {
    const mixpanel = useAnalytics();

    return (
        <MenuItem
            onClick={async event => {
                mixpanel?.track(`campaigns-${mixPanelEvent}`, { event: 'click', campaign, from: 'menu' });
                closeMenu();
                onClick(event);
            }}>
            <ListItemIcon>
                <MaskedIcon src={icon} size={'24px'} color={theme.colors.secondary.main} />
            </ListItemIcon>
            <ListItemText>{text}</ListItemText>
        </MenuItem>
    );
};
